import React, { useRef, useState } from 'react'

import useEscapeKey from './hook/useEscapeKey'
import useOutsideClick from './hook/useOutsideClick'
import {
  PromoEl,
  PromoInner,
  PromoInnerInner,
  PromoDismiss,
  PromoContent,
  PromoTitle,
  PromoSubTitle
} from './elements'
import PromoButton from './components/PromoButton'
import VideoLooper from './components/VideoLooper'

const Promo = ({
  imageSrc,
  title,
  subTitle,
  sessionDismissId,
  posterSrc,
  videoUrl,
  captionsSrc
}) => {
  const ref = useRef()
  const [expanded, toggleExpanded] = useState(false)
  const [dismissed, setDismissed] = useState(
    typeof window === 'undefined'
      ? false
      : sessionDismissId
      ? window.sessionStorage.getItem(`promoDismissed-${sessionDismissId}`)
      : false
  )

  const handleOpen = () => {
    toggleExpanded(true)
    document.addEventListener('touchmove', handleClose)
  }

  const handleClose = () => {
    toggleExpanded(false)
    document.removeEventListener('touchmove', handleClose)
  }

  const handleSetDismissed = () => {
    setDismissed(true)
    if (sessionDismissId)
      typeof window !== 'undefined' &&
        window.sessionStorage.setItem(
          `promoDismissed-${sessionDismissId}`,
          'true'
        )
  }

  useOutsideClick(ref, handleClose)
  useEscapeKey(handleClose)

  return (
    <span id="promo-placeholder">
      {!dismissed && (
        <PromoEl setRef={ref} expanded={expanded}>
          {!expanded && (
            <PromoInner
              onClick={handleOpen}
              {...(imageSrc && {
                style: { backgroundImage: `url(${imageSrc})` }
              })}
            >
              <PromoInnerInner>
                <PromoContent>
                  <PromoTitle>{title}</PromoTitle>
                  <PromoSubTitle>{subTitle}</PromoSubTitle>
                </PromoContent>
              </PromoInnerInner>
            </PromoInner>
          )}

          {expanded && (
            <div>
              <VideoLooper
                ratio={16 / 9}
                autoPlay
                poster={posterSrc}
                src={videoUrl}
              >
                {captionsSrc && (
                  <track kind="captions" srcLang="en" src={captionsSrc} />
                )}
              </VideoLooper>
            </div>
          )}

          <PromoDismiss expanded={expanded}>
            <PromoButton
              dim={!expanded}
              onClick={handleSetDismissed}
              label="Dismiss video thumbnail"
            >
              <svg viewBox="0 0 24 24">
                <path d="M18.6 16.9c.5.5.5 1.2 0 1.7-.2.2-.5.3-.9.3s-.6-.1-.9-.3L12 13.7l-4.9 4.9c-.3.3-.6.4-.9.4-.3 0-.6-.1-.9-.3-.5-.5-.5-1.2 0-1.7l4.9-4.9-4.8-5c-.5-.5-.5-1.2 0-1.7s1.2-.5 1.7 0l4.9 4.9 4.9-4.9c.5-.5 1.2-.5 1.7 0s.5 1.2 0 1.7L13.7 12l4.9 4.9z" />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
            </PromoButton>
          </PromoDismiss>
        </PromoEl>
      )}
    </span>
  )
}

export default Promo
